export const PHANTOM_TAB_TITLE = 'PHANTOM_TAB_TITLE'
export const PHANTOM_TAB_EDITOR = 'PHANTOM_TAB_EDITOR'



/** WEBPACK FOOTER **
 ** ./studio/constants.js
 **/